import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { api, today } from "@/lib/api";
import { Field, Note, act } from "@/components/common";
import { PayAccounts } from "@/components/PayAccounts";

export function ReportPayment({ url, title = "Make a payment", hint, onDone, testid = "report-payment" }) {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ amount: "", reference: "", date: today(), method: "mobile_money" });
  const submit = async () => {
    if (await act(() => api.post(url, f), "Thank you! We will check and confirm your payment.")) { setOpen(false); setF({ ...f, amount: "", reference: "" }); onDone?.(); }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild><Button className="bg-[#0369a1]" data-testid={`${testid}-button`}>{title}</Button></DialogTrigger>
      <DialogContent className="max-h-[90vh] overflow-y-auto">
        <DialogHeader><DialogTitle>Make a payment</DialogTitle></DialogHeader>
        <PayAccounts compact />
        <Note>Step 1: send the money to one of the company numbers above. Step 2: type the amount you sent and press Submit. Our team checks it arrived, then it shows in your account. {hint}</Note>
        <Field label="Amount sent (ZMW)"><Input inputMode="decimal" value={f.amount} onChange={(e) => setF({ ...f, amount: e.target.value })} data-testid={`${testid}-amount`} /></Field>
        <Field label="Transaction ID (optional)" hint="The code in the SMS you got after sending — helps us find it faster"><Input value={f.reference} onChange={(e) => setF({ ...f, reference: e.target.value })} data-testid={`${testid}-reference`} /></Field>
        <Button className="w-full bg-[#0369a1]" onClick={submit} data-testid={`${testid}-submit`}>Submit</Button>
      </DialogContent>
    </Dialog>
  );
}
